import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Clemson Tigers"
    subtitle="See the Clemson Tigers in action this season"
    teamId={teamIds['Clemson Tigers']}
  />
)
